export default __webpack_public_path__ + "static/media/button2c.e806f563.png";